import React from "react";
import { useTranslation } from "react-i18next";

export function EvaluationCriteria() {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-100">
            <span className="font-medium text-blue-600">1</span>
          </div>
          <div>
            <h3 className="font-medium">
              {t("thumbnailReviewer.evaluationCriteria.metric1Title")}
            </h3>
            <p className="text-sm text-gray-500">
              {t("thumbnailReviewer.evaluationCriteria.metric1Description")}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-green-100">
            <span className="font-medium text-green-600">2</span>
          </div>
          <div>
            <h3 className="font-medium">
              {t("thumbnailReviewer.evaluationCriteria.metric2Title")}
            </h3>
            <p className="text-sm text-gray-500">
              {t("thumbnailReviewer.evaluationCriteria.metric2Description")}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-purple-100">
            <span className="font-medium text-purple-600">3</span>
          </div>
          <div>
            <h3 className="font-medium">
              {t("thumbnailReviewer.evaluationCriteria.metric3Title")}
            </h3>
            <p className="text-sm text-gray-500">
              {t("thumbnailReviewer.evaluationCriteria.metric3Description")}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100">
            <span className="font-medium text-amber-600">4</span>
          </div>
          <div>
            <h3 className="font-medium">
              {t("thumbnailReviewer.evaluationCriteria.metric4Title")}
            </h3>
            <p className="text-sm text-gray-500">
              {t("thumbnailReviewer.evaluationCriteria.metric4Description")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
